import api, { IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import AProvider from "src/framework/providers/AProvider";
import { PossibilidadeNovaSolicitacaoResponse, SolicitacoesTrocaDistribuidor } from "./types";

class TrocarDistribuidor extends AProvider {
    constructor() {
        super("/cadastros/troca_distribuidor");
    }

    async verificarPossibilidadeNovaSolicitacao(contaCnpjCpf: string): Promise<PossibilidadeNovaSolicitacaoResponse | null> {
        const response = await api.post({
            url: `${this.path}/nova_solicitacao/verificar`,
            data: {
                conta_cnpj_cpf: contaCnpjCpf
            }
        })

        return response.data || null;
    }

    async getSolicitacoes(id: number): Promise<SolicitacoesTrocaDistribuidor[]> {
        const request: IDataRequest = { url: `${this.path}/${id}` }
        const response: IDataResponse = await api.get(request);
        if (response.statusCode === STATUS_CODE.OK) {
            return response.data?.data || response.data
        }
        return [];
    }

    async criarSolicitacao(data: any): Promise<{message: string[]} | null> {
        const request: IDataRequest = { url: `${this.path}/criar_solicitacao`, data }
        const response: IDataResponse = await api.post(request);
        if ([STATUS_CODE.OK, STATUS_CODE.CREATED].includes(response.statusCode)) {
            return response.data || []
        }

        return null
    }
}

export { TrocarDistribuidor }